import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect, NavLink } from 'react-router-dom';
import reactStringReplace from 'react-string-replace';

import HelmetMeta from '../../components/HelmetMeta';
import { is_Preview } from '../../utils/Helper';

import c from '../../config';

const NoMatch = ({ i18n }) => {
  const { translations = {}, locale } = i18n || {};
  const { pagenotfound = {} } = translations[locale] || {};

  const seo = {
    seo_title: 'Page not found',
  };

  const [seconds, setSeconds] = useState(c.redirectHomeTimeoutSecond);

  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    }
  });

  const homeUrl = locale === 'en' && is_Preview === false ? '/' : `/${locale}/`;

  const redirectHTML = reactStringReplace(
    pagenotfound.redirect || '',
    /\[(.*?)\]/gim,
    (match, index) => {
      console.log(match, index);
      if (index === 1) {
        return (
          <NavLink to={(location) => ({ ...location, pathname: c.routePathTo + homeUrl })}>
            {match}
          </NavLink>
        );
      }
      if (match === 'sec') {
        return <>{seconds}</>;
      }
      return match;
    },
  );

  return (
    <>
      {seconds > 0 ? (
        <div>
          <div className="sec-intro">
            <h2 className="sec-intro__title">{pagenotfound.title}</h2>
          </div>
          <div className="container">
            <p className="align-center">{pagenotfound.desc}</p>
            <p className="align-center">{redirectHTML}</p>
          </div>
          <HelmetMeta seo={seo} status="404" />
        </div>
      ) : (
        <Redirect to={c.routePathTo + homeUrl} />
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  i18n: state.i18n,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(NoMatch);

export { NoMatch as NoMatchComponent }; // <- For component Unit Test
export default connectStore;
